import { useNuxtApp, useSeoMeta } from 'nuxt/app';
import { computed, toValue, type MaybeRefOrGetter } from 'vue';
import { sanityImageWithAsset } from '@pkg/sanity-utils/sanityImageWithAsset';
import type { PageSeo } from '@pkg/sanity-utils/types/seo';

function text(value?: string | null) {
  const trimmed = value?.trim();
  return trimmed || undefined;
}

/**
 * Page overrides for the site defaults set by `useSanityDefaultSeoMeta`.
 * Empty fields are left unset so the site title, description, and image stay.
 */
export function useSanityPageSeoMeta(pageSeoMaybeRef: MaybeRefOrGetter<PageSeo | null | undefined>) {
  const { $urlFor } = useNuxtApp();
  const pageSeo = computed(() => toValue(pageSeoMaybeRef));

  useSeoMeta({
    title: () => text(pageSeo.value?.metaTitle),
    ogTitle: () => text(pageSeo.value?.metaTitle),
    description: () => text(pageSeo.value?.metaDescription),
    ogDescription: () => text(pageSeo.value?.metaDescription),
    ogImage: () => {
      const image = sanityImageWithAsset(pageSeo.value?.socialImage);
      if (!image) {
        return undefined;
      }
      return $urlFor(image).width(1200).fit('max').quality(90).url();
    },
  });
}
